import { FraudAlertsService } from 'apps/phoenix/src/app/features/fraud-alerts/services/fraud-alerts.service';
import { PhoenixTrpcClient } from 'apps/phoenix/src/app/utils';
import { Subject, debounceTime, from, takeUntil } from 'rxjs';

import { Component, Input, OnInit, inject } from '@angular/core';
import { FormControl } from '@angular/forms';

import { UiHelpersService } from '../../services';

@Component({
  standalone: false,
  selector: 'phoenix-validate-ta-input',
  templateUrl: './validate-ta-input.component.html',
})
export class ValidateTAInputComponent implements OnInit {
  @Input() controlForm = new FormControl('');
  @Input() ariaInput = '';
  @Input() ariaLoading = '';
  trpcService = inject(PhoenixTrpcClient);
  uiHelper = inject(UiHelpersService);
  fraudAlertsService = inject(FraudAlertsService);
  destroy$ = new Subject();
  loadingValidation = 0;

  ngOnInit() {
    this.controlForm.valueChanges
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.setErrors('invalidID');
      });

    this.controlForm.valueChanges
      .pipe(debounceTime(500), takeUntil(this.destroy$))
      .subscribe(value => {
        if (value) {
          this.setErrors('invalidID');
          this.validateTAObjectID(value);
        }
      });
  }

  validateTAObjectID(id: string) {
    from(
      this.trpcService.directCollect.get.query({
        id,
      })
    )
      .pipe(takeUntil(this.destroy$))
      .subscribe({
        next: data => {
          this.loadingValidation--;
          if (data) {
            this.setErrors();
            this.uiHelper.snackBar.dismiss();
          }
        },
        error: () => {
          this.loadingValidation--;
          this.setErrors('invalidID');
        },
      });
  }

  setErrors(errorType?: string) {
    const controlErrors = this.controlForm?.errors ?? {};

    delete controlErrors?.['invalidID'];
    delete controlErrors?.['loadingValidation'];

    const errors = {
      ...controlErrors,
      ...(errorType === 'invalidID' && { invalidID: true }),
      ...(this.loadingValidation > 0 && { loadingValidation: true }),
    };

    this.controlForm.setErrors(Object.keys(errors).length > 0 ? errors : null);
  }
}
